import { BehaviorSubject } from 'rxjs';

const cartSubject = new BehaviorSubject<{ [key: string]: any }>({});
const invoiceSummarySubject = new BehaviorSubject<{ [key: string]: any }>({});

export const UnifiedPaymentDataService = {
  setPaymentInfo: (lob: string, cartInfo: any, errorStatus: boolean) => {
    const currentCartInfo = cartSubject.getValue();
    cartSubject.next({
      ...currentCartInfo,
      [lob]: { cartInfo, errorStatus },
    });
  },
  getPaymentInfo: (): any => cartSubject.getValue(),
  setInvoiceSummary: (lob: string, summary: any) => {
    const current = invoiceSummarySubject.getValue();
    invoiceSummarySubject.next({
      ...current,
      [lob]: summary,
    });
  },
  getInvoiceSummary: (): any => invoiceSummarySubject.getValue(),
};
